import { Box, Button, Fade, MenuItem, styled, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { UserModel } from 'services/types/User'
import { useLocation } from 'react-router-dom'
import { useAppDispatch } from 'state/hooks'
import { logoutThunk } from 'state/user/actions'
import theme from 'theme'
import { menus } from 'utils/userMenu'
import AccountCertification from 'components/AccountCertification'
import { FlexCenterBox } from 'styleds'
import SmileyPic from 'assets/images/svg/smiley.svg'

const AvatarButton = styled(Button)`
  outline: none;
  min-width: 48px;
  padding: 0;
  position: relative;
  margin-left: 33px !important;
  :hover {
    background: transparent !important;
  }
  .active {
    background: rgba(255, 255, 255, 0.1);
  }
`
const AvatarBox = styled(Box)`
  :hover {
    /* background: rgba(255, 255, 255, 0.1); */
  }
  /* width: 80px; */
  /* height: 80px; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  img {
    width: 56px;
    height: 56px;
    object-fit: cover;
  }
  .MuiBox-root {
    width: 56px;
    height: 56px;
    background: ${props => props.theme.colors.background.body};
    display: flex;
    align-items: center;
    font-size: 24px;
    color: ${theme.palette.common.white};
    justify-content: center;
  }
`

const MItems = styled(MenuItem)`
  padding: 16px 24px;
  justify-content: flex-start !important;
  &:not(:first-of-type) {
    border-top: 1px solid #323232;
  }
`
const Wrapper = styled(Fade)`
  position: absolute;
  width: 413px;
  background: ${props => props.theme.colors.black};
  top: 56px;
  right: 0;
  z-index: 13;
  transition: all(0.5s);
  overflow-y: auto;
  padding: 4px 0px;
`

export default function Avatar({ user }: { user: UserModel | null }) {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const [open, setOpen] = useState<boolean>(false)
  const theme = useTheme()
  const handleClose = (type: string, link?: string) => {
    setOpen(false)
    if (type === 'Log Out') {
      dispatch(logoutThunk())
      // window.sessionStorage.setItem('globalAnnouncement', 'false')
    } else if (typeof type === 'string') {
      if (link) {
        if (type === 'Profile') {
          window.location.href = `/u/${user?.uid}`
        } else {
          window.location.href = link
        }
      }
    }
  }
  return (
    <>
      <AvatarButton
        id="basic-button"
        onClick={e => {
          e.preventDefault()
        }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <AvatarBox className={location.pathname === '/uc' ? 'active' : ''}>
          {user && user.headIcon ? (
            <img src={user.headIcon} alt="" />
          ) : (
            <Box>{user && user.account.substring(0, 1)}</Box>
          )}
        </AvatarBox>
        {open && (
          <Wrapper in={open}>
            <Box>
              {user && (
                <>
                  <img
                    width="88px"
                    height="88px"
                    src={user.headIcon || SmileyPic}
                    alt=""
                    style={{ marginTop: '16px', marginBottom: '16px', borderRadius: '50%' }}
                  ></img>
                </>
              )}
              <Typography fontWeight={700} fontSize="20px" marginBottom="32px" padding="0 24px" component="div">
                <FlexCenterBox justifyContent="center">
                  <Box maxWidth="300px" overflow="hidden" sx={{ whiteSpace: 'nowrap' }} textOverflow="ellipsis">
                    {user?.nickName}
                  </Box>
                  <AccountCertification
                    name={user?.certificationName}
                    explain={user?.certificationExplain}
                  ></AccountCertification>
                </FlexCenterBox>
              </Typography>
              {menus.map(el => (
                <MItems key={`header_menu${el.text}`} onClick={() => handleClose(el.text, el.link)}>
                  {/* <img src={el.icon} alt="" style={{ marginRight: '16px' }}></img> */}
                  <Typography variant="body1" color={theme.colors.white} fontWeight="700" lineHeight="1.5">
                    {el.text}
                  </Typography>
                </MItems>
              ))}
            </Box>
          </Wrapper>
        )}
      </AvatarButton>
    </>
  )
}
